import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'RangeInput' }

import { computed, type PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  min: { type: Number as PropType<number | null>, default: null },
  max: { type: Number as PropType<number | null>, default: null },
  minFloor: { type: Number, default: 1 },
  size: { type: String as PropType<'sm' | 'md'>, default: 'md' },
  disabled: { type: Boolean, default: false },
  error: { type: [Boolean, String] as PropType<boolean | string>, default: false },
  minPlaceholder: { type: String, default: '' },
  maxPlaceholder: { type: String, default: '' }
},
  emits: ["update:min", "update:max"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:min', value: number | null): void
  (e: 'update:max', value: number | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

// A min to max whole-number range (participant counts, player bands) in one
// bordered group. Two-way bound through `min.sync` / `max.sync`.




const errorMessage = computed(() => (typeof props.error === 'string' ? props.error : ''))

function normalize(v: number | null | undefined): number | null {
  return v == null ? null : v
}

return { __sfc: true,props, emit, errorMessage, normalize }
}

})